import { render } from "./ClientRequests.vue?vue&type=template&id=e31476d0&scoped=true"
import script from "./ClientRequests.vue?vue&type=script&lang=js"
export * from "./ClientRequests.vue?vue&type=script&lang=js"

import "./ClientRequests.vue?vue&type=style&index=0&id=e31476d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e31476d0"]])

export default __exports__